import { StatusCircle } from "Global/StatusCircle";
import Flex from "common/Boxes/Flex";
import { useTheme } from "styled-components";
import { CommissionStatus, PayoutStatus } from "types/affiliation.types";
import { StatusChip } from "features/affiliation/NewLook/roles";

interface StatusProps {
  itemStatus: typeof CommissionStatus | typeof PayoutStatus;
  status: CommissionStatus | PayoutStatus;
  statusDisplayName: string;
}

const Status = ({ itemStatus, status, statusDisplayName }: StatusProps) => {
  const appTheme = useTheme();
  let color;
  if (status === itemStatus.PENDING) color = appTheme.colors.orange;
  else if (status === itemStatus.APPROVED) color = appTheme.colors.green;
  else if (
    status === itemStatus.CANCELLED ||
    status === PayoutStatus.DENIED ||
    status === CommissionStatus.PAYMENT_REFUNDED
  )
    color = appTheme.colors.red;

  // New look: a neutral chip whose dot carries the meaning (waiting is grey,
  // not orange: nothing is wrong yet).
  if (appTheme.isNewLook) {
    const tone =
      status === itemStatus.APPROVED
        ? "up"
        : color === appTheme.colors.red
        ? "down"
        : "neutral";
    return <StatusChip tone={tone}>{statusDisplayName}</StatusChip>;
  }

  return (
    <Flex $justifyContent="start">
      {color && (
        <StatusCircle
          color={color}
          $animated={false}
          style={{ marginRight: 6 }}
        />
      )}
      {statusDisplayName}
    </Flex>
  );
};

export default Status;
